let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class EventDetailService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.SessionService = SessionService;
    }
    getEvent(id){
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getEvent + "?id=" +id,
          cache : true
        }).then((response) => {
          resolve(response.data);
        }, (reason) => {
          reject(reason);
        });
      });
    }


}

EventDetailService.$inject = inject;

export default EventDetailService;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/events/event-detail/event-detail.service.js
 **/